import { Pool, TicketBody } from './types';
import { deleteData, getData, put } from 'services/api';

import { decamelizeKeys } from 'humps';
import { keepUpperCase } from 'utils/utils';

export const deleteTicket = (id: number) => {
	return deleteData(`/ticket_types/${id}`);
};

export const updateTicket = (body: TicketBody) => {
	return put(
		`/ticket_types/${body.ID}`,
		decamelizeKeys(body, {
			process: keepUpperCase,
		})
	);
};

export const getEventPools = (eventId: number): Promise<Pool[]> => {
	return getData(`/events/${eventId}/pools`);
};
